<template>
  <div class="Generating">
    <div class="campus">
      激活码管理
      <span>></span>教材二维码管理
    </div>
    <div class="xiaoqu moerduo">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-card>
            <div class="grid-content bg-purple scrollbarStyle treeStyle dialogStyle" style="height: 85vh; overflow: auto">
              <!-- 导出报表会话框 -->
              <el-dialog title="确认导出" :visible.sync="exportDialog" width="600px" center>
                <div class="form_1 form_1_1">
                  <el-row class="chakanss">
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        教材名称：
                        <span>{{ bookid_1label }}</span>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple-light">
                        学校名称：
                        <span>{{ bookid_2label }}</span>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="chakanss mt-20">
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        创建数量：
                        <span>{{ jihuoma_shuliang }}</span>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple-light">
                        激活码有效期：
                        <span>{{ jhm_yxq }}</span>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="chakanss mt-20">
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        渠道：
                        <span>{{ channel_str_show }}</span>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple-light">
                        批次：
                        <span>{{ batch_str_x }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="submitExport">确定</el-button>
                  <el-button @click="exportDialog = false">取消</el-button>
                </span>
              </el-dialog>

              <div class="xiaoqu_1 header">选择教材</div>

              <el-tree ref="tree" :data="data2" :highlight-current="true" @node-click="handleNodeClick" :props="props" node-key="id"
                :default-checked-keys="[bookid_1]" @check-change="dianxuan">
                <span class="span-ellipsis" slot-scope="{ node }">
                  <span :title="node.label">{{ node.label }}</span>
                </span>
              </el-tree>
              <el-tree ref="tree1" :data="data3" :highlight-current="true" @node-click="handleNodeClick0" :props="props" node-key="id"
                :default-checked-keys="[bookid_2]" @check-change="dianxuan1">
                <span class="span-ellipsis" slot-scope="{ node }">
                  <span :title="node.label">{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </el-card>
        </el-col>
        <el-col :span="19">
          <el-card>
            <div class="grid-content bg-purple scrollbarStyle shengchengma" style="height: 85vh; overflow: auto">
              <div class="xiaoqu_1  header">生成码</div>
              <div class="dz-flex dz-flex-justify-space ">
                <div class="sousuo dz-flex dz-flex-align-center chuangjian_left">
                  <span style="width: 90px;">创建数量<span style="color: red;">*</span>：</span>
                  <el-input @input="handleInput" placeholder="请输入创建的激活码数量" v-model="jihuoma_shuliang" maxlength="5" clearable></el-input>

                  <span class="ml-30" style="width: 75px;">有效期<span style="color: red;">*</span>：</span>
                  <el-select v-model="jhm_yxq" clearable>
                    <el-option @click.native="jhm_yxq1 = item.day" v-for="(item, index) in xuanzeyouxiaoqi" :value="item.month"
                      :key="index">{{item.month}}</el-option>
                  </el-select>

                  <span class="ml-30" style="width: 50px;">渠道：</span>
                  <el-select v-model="channel_str_show" clearable>
                    <el-option @click.native="channel_str = item.code" v-for="(item, index) in channel_list" :value="item.name"
                      :key="index">{{item.name}}</el-option>
                  </el-select>

                  <span class="ml-30" style="width: 50px;">批次：</span>
                  <el-input @input="handleInput2" placeholder="请输入批次码" v-model="batch_str" maxlength="20" clearable></el-input>

                  <el-button type="primary" class=" ml-25" @click="exportExcel">导出</el-button>
                </div>

              </div>
              <div class="clear"></div>
              <div>
                <div class="tableStyle">
                  <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="activecode" label="激活码" align="center"></el-table-column>
                    <el-table-column prop="bookname" label="教材" align="center"></el-table-column>
                    <el-table-column prop="orgname" label="学校" align="center"></el-table-column>
                    <el-table-column prop="create_date" label="创建时间" align="center"></el-table-column>
                  </el-table>
                </div>
                <div class="dz-flex dz-flex-justify-end mt-12">
                  <el-pagination class="fenye_jihuo" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
// import { $getTimList } from '@/api/code';
import { $debounce } from '@/utils/index';
import { stringify } from 'json5';
export default {
  name: 'Generating',
  data() {
    return {
      props: {
        children: 'children',
        label: 'label',
      },
      formss: {},
      FormRules: {},
      timetotime: '',
      jihuoma: '',
      showCreateTime: '',
      data2: [],
      bookid_1: '',
      bookid_2: '',
      bookid_1label: '',
      bookid_2label: '',
      pageSize: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
      data3: [],
      xuanzeyouxiaoqi: [],
      channel_list: [],
      jhm_yxq: '',
      jhm_yxq1: '',
      channel_str: '',
      channel_str_show: '',
      jihuoma_shuliang: '',
      batch_str: '',
      batch_str_x: '',
      // 导出报表 会话框
      exportDialog: false,
      page: '',
      s0s: 1,
    };
  },
  watch: {
    timetotime() {
      // console.log(n, o)
      this.selectActiveCodeList();
    },
  },
  created() {
    this.miniInfoSetting();
    this.getSchoolTree();
    this.getTimList();
    this.getChannelList();
    this.selectActiveCodeList();
  },
  methods: {
    formateDate(datetime) {
      function addDateZero(num) {
        return num < 10 ? '0' + num : num;
      }
      let d = new Date(datetime);
      let formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate()) + ' ' + addDateZero(d.getHours()) + ':' + addDateZero(d.getMinutes()) + ':' + addDateZero(d.getSeconds());
      return formatdatetime;
    },

    fenfagai(id) {
      // console.log(id)
      if (id.fenfa0 === true) {
        return false;
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要分发吗?', '分发', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // axios请求服务器端实现分发
        let pro = this.$http({
          url: '/edu/activecode/updateStatusById',
          data: {
            id: id.id,
            status: 1,
          },
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // 分发成功
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.selectActiveCodeList();
          })
          .catch((err) => {
            // console.log(err)
            return this.$message.error('分发激活码失败：' + err);
          });
      });
    },

    dianxuan() {
      this.$refs.tree.setCheckedKeys([]);
    },
    dianxuan1() {
      this.$refs.tree1.setCheckedKeys([]);
    },
    handleNodeClick(data) {
      // console.log(data)
      if (data.type === 0) {
        this.bookid_1 = data.id;
        this.bookid_1label = data.label;
        // console.log(this.bookid_1)
        this.selectActiveCodeList();
      } else {
        this.bookid_1 = '';
        this.bookid_1label = '';
      }
    },

    handleNodeClick0(data) {
      // console.log(data)
      if (data.type === 0) {
        this.bookid_2 = data.id;
        this.bookid_2label = data.label;
        this.selectActiveCodeList();
      } else {
        this.bookid_2 = '';
        this.bookid_2label = '';
      }
    },

    handleInput(e) {
      this.jihuoma_shuliang = e.replace(/\D/g, '').replace(/^0{1,}/g, '');
    },
    handleInput2(e) {
      this.batch_str = e;
    },

    // 导出报表
    exportExcel() {
      if (this.bookid_1 === '') {
        return this.$message.error('激活码所在教材未选择！');
      }
      if (this.bookid_2 === '') {
        return this.$message.error('激活码所在学校未选择！');
      }
      if (this.jihuoma_shuliang === '' || +this.jihuoma_shuliang > 100) {
        return this.$message.error('激活码数量不能为空！且数量不得大于100！');
      }
      if (this.jhm_yxq === '') {
        return this.$message.error('激活码有效期未选择！');
      }
      if (this.channel_str_show === '') {
        this.channel_str = '';
      }
      if (this.batch_str != "" && this.batch_str != null && this.batch_str != undefined) {
        this.getBatch(this.batch_str)
        if (this.batch_str_x === ''){
          return this.$message.error('请填入正确的批次码');
        }
      }
      this.exportDialog = true;
    },
    // 确认导出 async
    submitExport: $debounce(function () {
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        // url: '/edu/activecode/exportQRCode',
        // method: 'POST',
        // data: {
        //   bookid: this.bookid_1,
        //   schoolid: this.bookid_2,
        //   allNum: +this.jihuoma_shuliang,
        //   validday: this.jhm_yxq1,
        //   bookname: this.bookid_1label,
        //   schoolname: this.bookid_2label,
        // },
        url: '/management/img-matrix/book/qr_code/img/download',
        method: 'POST',
        data: {
          bookId: this.bookid_1,
          count: +this.jihuoma_shuliang,
          lifeTime: this.jhm_yxq1,
          channel: this.channel_str,
          batch: this.batch_str,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
        responseType: 'blob',
      });
      pro
        .then((res) => {
          if (!res.data) {
            this.$message.error('导出失败！');
            this.exportDialog = false;
            loading.close();
            return;
          }
          this.$message.success('导出成功!');
          this.exportDialog = false;
          console.log(res.data);
          let url = window.URL.createObjectURL(new Blob([res.data]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', this.bookid_1label + '_激活码_' + (+this.jihuoma_shuliang) + '.zip');
          document.body.appendChild(link);
          link.click();
          loading.close();
        })
        .catch(() => {});
    }, 500),
    // 查询激活码
    selectActiveCodeList() {
      let timetotime = this.timetotime;
      let fromtime = '';
      let totime = '';
      if (timetotime !== '' && timetotime !== null) {
        let size = timetotime.length;
        // console.log(size)
        if (size === 1) {
          fromtime = timetotime[0];
        } else if (size === 2) {
          fromtime = timetotime[0];
          totime = timetotime[1];
        }
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/activecode/selectActiveCodeList',
        method: 'POST',
        data: {
          bookid: this.bookid_1,
          schoolid: this.bookid_2,
          status: this.s0s,
          page: this.page,
          pageSize: this.pageSize,
          fromtime: fromtime,
          totime: totime,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tableData = result.data.data;
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].create_date = this.formateDate(this.tableData[i].create_date);
            this.tableData[i].fenfa0 = false;
            if (this.tableData[i].status === 1) {
              this.tableData[i].status = '已分发';
              this.tableData[i].fenfa0 = true;
            }
            if (this.tableData[i].status === 0) {
              this.tableData[i].status = '分发';
            }
          }
          if (result.data.data === undefined || result.data.data === null) {
            this.total = 0;
          } else {
            this.total = result.data.size;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询激活码失败：' + err);
        });
    },

    // 查询激活码有效期
    async getTimList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/activecode/getTimList',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.xuanzeyouxiaoqi = result.data.data;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询激活码有效期失败：' + err);
        });
      // const res = await $getTimList();
      // if (res.data.code === 0) {
      //   this.xuanzeyouxiaoqi = res.data.data;
      // } else {
      //   this.$message.error(res.data.message);
      // }
    },

    // 查询渠道列表
    async getChannelList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/management/statistic/data/channel?page=1&size=100000',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 2000) {
            return this.$message.error(result.data.msg);
          }
          this.channel_list = result.data.data;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询渠道列表失败：' + err);
        });
    },

    getBatch(batchCode) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/management/statistic/batch/one?code=' + batchCode,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 2000) {
            return this.$message.error(result.data.msg);
          }
          this.batch_str_x = result.data.data.code;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询批次失败：' + err);
        });
    },

    // 查询教材
    miniInfoSetting() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/book/getGroupTree/' + orgid,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.data2 = result.data.data;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询教材失败：' + err);
        });
    },

    // 查询校区
    getSchoolTree() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/org/getSchoolTree',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.data3 = result.data.data;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询校区失败：' + err);
        });
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      // this.$options.methods.chaxun()
      this.selectActiveCodeList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.selectActiveCodeList();
    },
  },
  destroyed() {},
};
</script>

<style lang="less" scoped>
.fenfa1 {
  color: #666 !important;
}
.Generating .xiaoqu {
  .shengchengma {
    .chuangjian_left {
      float: left !important;
    }
    .sousuo {
      margin-bottom: 30px;
      .el-input {
        width: 200px;
      }
      .el-select {
        width: 110px;
      }
      .el-date-editor {
        width: 220px;
      }
    }
    .sousuo .el-range-editor.el-input__inner {
      padding: 0;
    }
    .sousuo .el-date-editor {
      .el-range__icon {
        margin-left: 15px;
        margin-top: -4px;
      }
    }
    .xiaoqu_1 {
      left: 0;
    }
  }
  .grid-content {
    .xuan_shengcheng {
      margin-bottom: 35px;
    }
    .el-tree {
      margin-top: 10px;
    }
  }
}
.el-card__body {
  padding: 0 20px;
}
</style>
